import { setMixedContentInOrder, setPersonalSpaceContentInOrder, setFavoriteMixedContentInOrder, setExplorableItemDefinitions, setContentSpaceDefinitions } from '~src/contentDefinitionInterfaces/ContentDefinitionsLists';
import { MixedContentItemDefinition, ExplorableItemDefinition, SpaceDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { MetricDefinition } from '~src/metrics/models/MetricDefinition';
import { ExplorableItemType, SpaceInfoItemType } from '~src/ts/models/ContentType';

import { AccelerationTaskDefinition } from './AccelerationTaskDefinition';
import { BackgroundJobDefinition } from './BackgroundJobDefinition';
import { CollectionDefinition } from './CollectionDefinition';
import { ConnectedWorkbooksInDatasourceDefinition } from './ConnectedWorkbooksInDatasourceDefinition';
import { CustomViewDefinition } from './CustomViewDefinition';
import { DataAlertDefinition } from './DataAlertDefinition';
import { DatabaseWithCrassDefinition, DatabaseDefinition } from './DatabaseDefinition';
import { DataConnectionDefinition } from './DataConnectionDefinition';
import { DataConnectionInDatasourceDefinition } from './DataConnectionInDatasourceDefinition';
import { DataRoleDefinition } from './DataRoleDefinition';
import { DatasourceDefinition } from './DatasourceDefinition';
import { ExtractTaskDefinition } from './ExtractTaskDefinition';
import { FlowDefinition } from './FlowDefinition';
import { FlowOutputStepRunDefinition } from './FlowOutputStepRunDefinition';
import { GroupDefinition } from './GroupDefinition';
import { LensDefinition } from './LensDefinition';
import { ProjectDefinition } from './ProjectDefinition';
import { PublishedConnectionDefinition } from './PublishedConnectionDefinition';
import { RecommendedViewDefinition } from './RecommendedViewDefinition';
import { RemoteRefreshSchedulesDefinition } from './RemoteRefreshSchedulesDefinition';
import { RunFlowTaskDefinition } from './RunFlowTaskDefinition';
import { ScheduleDefinition } from './ScheduleDefinition';
import { SearchUserDefinition } from './SearchUserDefinition';
import { ServerUserDefinition } from './ServerUserDefinition';
import { SiteDefinition } from './SiteDefinition';
import { SiteUserDefinition } from './SiteUserDefinition';
import { SubscriptionDefinition } from './SubscriptionDefinition';
import { TableWithCrassDefinition, TableDefinition } from './TableDefinition';
import { ViewDefinition } from './ViewDefinition';
import { WorkbookAccelerationDefinition } from './WorkbookAccelerationDefinition';
import { WorkbookDefinition } from './WorkbookDefinition';


const mixedContentInOrder: MixedContentItemDefinition[] = [
  ProjectDefinition,
  WorkbookDefinition,
  ViewDefinition,
  MetricDefinition,
  LensDefinition,
  DatasourceDefinition,
  FlowDefinition,
  DataRoleDefinition,
  PublishedConnectionDefinition,
];

const personalSpaceContentInOrder: MixedContentItemDefinition[] = [
  WorkbookDefinition,
  DatasourceDefinition,
];

const favoriteMixedContentInOrder: MixedContentItemDefinition[] = [
  ProjectDefinition,
  WorkbookDefinition,
  ViewDefinition,
  MetricDefinition,
  DatasourceDefinition,
  FlowDefinition,
  DataRoleDefinition,
  CollectionDefinition,
  PublishedConnectionDefinition,
];

const explorableItemDefinitions: Record<ExplorableItemType, ExplorableItemDefinition> = {
  project: ProjectDefinition,
  workbook: WorkbookDefinition,
  lens: LensDefinition,
  datasource: DatasourceDefinition,
  dataRole: DataRoleDefinition,
  view: ViewDefinition,
  dataconnection: DataConnectionDefinition,
  flow: FlowDefinition,
  customView: CustomViewDefinition,
  subscription: SubscriptionDefinition,
  accelerationTask: AccelerationTaskDefinition,
  extractTask: ExtractTaskDefinition,
  workbookAcceleration: WorkbookAccelerationDefinition,
  connection: DataConnectionInDatasourceDefinition,
  remoteRefreshSchedule: RemoteRefreshSchedulesDefinition,
  connectedWorkbook: ConnectedWorkbooksInDatasourceDefinition,
  flowOutputStepRun: FlowOutputStepRunDefinition,
  backgroundJob: BackgroundJobDefinition,
  databaseWithCrass: DatabaseWithCrassDefinition,
  tableWithCrass: TableWithCrassDefinition,
  database: DatabaseDefinition,
  table: TableDefinition,
  metric: MetricDefinition,
  siteuser: SiteUserDefinition,
  serveruser: ServerUserDefinition,
  searchuser: SearchUserDefinition,
  recommendedView: RecommendedViewDefinition,
  dataalert: DataAlertDefinition,
  site: SiteDefinition,
  schedule: ScheduleDefinition,
  runFlowTask: RunFlowTaskDefinition,
  group: GroupDefinition,
  collection: CollectionDefinition,
  publishedConnection: PublishedConnectionDefinition,
};

const contentSpaceDefinitions: { [C in SpaceInfoItemType]: SpaceDefinition<C> } = {
  project: ProjectDefinition,
  workbook: WorkbookDefinition,
  lens: LensDefinition,
  datasource: DatasourceDefinition,
  view: ViewDefinition,
  flow: FlowDefinition,
  dataRole: DataRoleDefinition,
  group: GroupDefinition,
  siteuser: SiteUserDefinition,
  serveruser: ServerUserDefinition,
  schedule: ScheduleDefinition,
  metric: MetricDefinition,
  collection: CollectionDefinition,
  publishedConnection: PublishedConnectionDefinition,
};


setMixedContentInOrder(mixedContentInOrder);
setPersonalSpaceContentInOrder(personalSpaceContentInOrder);
setFavoriteMixedContentInOrder(favoriteMixedContentInOrder);
setExplorableItemDefinitions(explorableItemDefinitions);
setContentSpaceDefinitions(contentSpaceDefinitions);

